var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 4.375V4.375C12.25 3.32663 12.25 2.80245 12.0787 2.38896C11.8504 1.83765 11.4124 1.39963 10.861 1.17127C10.4476 1 9.92337 1 8.875 1H5.5C3.37868 1 2.31802 1 1.65901 1.65901C1 2.31802 1 3.37868 1 5.5V8.875C1 9.92337 1 10.4476 1.17127 10.861C1.39963 11.4124 1.83765 11.8504 2.38896 12.0787C2.80245 12.25 3.32663 12.25 4.375 12.25V12.25",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.125
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.75,
    y: 7.75,
    width: 11.25,
    height: 11.25,
    rx: 2.25,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.ae95321854d14bd33d21e612869dd4c1.svg";
export { ForwardRef as ReactComponent };